import {
  Avatar,
  Container,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useAppSelector, useAuth, useDispatchApp, useIsDesktop } from 'Hooks';
import { UserInfo, Header2, Footer2, BurgerMenu } from 'Components';
import { BGDesktop, BGNewMobile } from 'Images';
import { B2CGuard } from 'Components/B2CGuard';
import { useScrollTopView } from 'Hooks/useScrollTopView';
import { useCallback, useEffect } from 'react';
import { getBurgerMenuItems } from 'API/Home/burgerMenuItems';
import { setMenuItems } from 'Store/MenuItemsSlice';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';

export const PrivateLayout = () => {
  const { isAuth, isOtp } = useAuth();
  const { inProgress } = useMsal();
  useScrollTopView({ smoothScroll: true });

  const isDesktop = useIsDesktop();
  const theme = useTheme();
  const isScreenXl = useMediaQuery(theme.breakpoints.up('xl'));

  const burgerMenuItems = useAppSelector(
    ({ menuItems: { menuItems } }) => menuItems
  );

  const dispatch = useDispatchApp();

  const initMenuItems = useCallback(async () => {
    if (burgerMenuItems?.length === 0) {
      const menuItemsResult = await getBurgerMenuItems();
      dispatch(setMenuItems(menuItemsResult));
    }
  }, [dispatch, burgerMenuItems]);

  useEffect(() => {
    if (inProgress === InteractionStatus.None && (isOtp || isAuth))
      initMenuItems();
  }, [inProgress, initMenuItems, isAuth, isOtp]);

  return (
    <B2CGuard>
      <Header2 />
      <Stack bgcolor={isDesktop ? 'primary.shade_50' : undefined}>
        <Avatar
          src={isDesktop ? BGDesktop : BGNewMobile}
          alt={''}
          sx={{
            width: isDesktop && isScreenXl ? 'calc(100vw - 300px)' : 'auto',
            height: isDesktop ? '660px' : '335px',
            position: 'absolute',
            top: '72px',
            left: 0,
            right: 0,
          }}
        />

        <Container component={'main'}>
          <Stack
            direction={'row'}
            sx={{
              minHeight: 'calc(100vh - 72px - 100px)',
            }}
          >
            <BurgerMenu />
            <Stack
              paddingTop={{ sm: '28px', xs: '20px' }}
              paddingBottom={{ sm: '80px', xs: '65px' }}
              paddingLeft={{ lg: '65px', sm: '24px', xs: '0' }}
              paddingRight={{ sm: '24px', xs: '0' }}
            >
              <UserInfo />
              <Outlet />
            </Stack>
          </Stack>
        </Container>
      </Stack>
      <Footer2 />
    </B2CGuard>
  );
};
